import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import {Ng2Webstorage} from 'ngx-webstorage';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { BlockUIModule } from 'ng-block-ui';
import {DataTableModule} from 'primeng/components/datatable/datatable';
import { SharedModule} from 'primeng/primeng';
import { AutoCompleteModule} from 'primeng/components/autocomplete/autocomplete';
import { RadioButtonModule} from 'primeng/components/radiobutton/radiobutton';
import { InputMaskModule} from 'primeng/components/inputmask/inputmask';
import { FileUploadModule} from 'primeng/components/fileupload/fileupload';
import {CheckboxModule} from 'primeng/components/checkbox/checkbox';
import { MenuModule } from 'primeng/components/menu/menu';
import { ButtonModule} from 'primeng/components/button/button';
import {SelectButtonModule} from 'primeng/components/selectbutton/selectbutton';
import { UiSwitchModule } from 'ngx-ui-switch/src';

// import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
// import { InMemoryClmtlkMockService} from 'mockdata/InMemoryClmtlkMockService';

import { ToastrModule } from 'ngx-toastr';

// CLMTLK Imports
import { UnauthorizeComponent } from 'app/common/component/401-unauthorize.component';
import { ClmtlkCanDeactivate } from 'app/clmtlk/shared/service/clmtlk-candeactivate.service';
import {WindowRefService } from './common/service/window-ref.service';
import { GoogleAnalyticsService } from 'app/common/service/google-analytics.service';
import { HelperService } from 'app/common/service/model-helper.service';
import { ExceptionService } from 'app/common/service/exception.service';
import { ClmtlkService } from './clmtlk/shared/service/clmtlk.service';
import { ClmtlkSessionService } from './clmtlk/shared/service/clmtlk-session.service';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './clmtlk/core/core.module';
import {SharedModule as ClmtlkSharedModule } from './clmtlk/shared/shared.module';
// import { InboxModule } from './clmtlk/inbox/inbox.module';
// import { ThreadModule } from './clmtlk/thread/thread.module';
// import { NewMessageModule } from './clmtlk/new-message/new-message.module';

// CLMTLK login
import { LoginComponent } from './clmtlk/login/login.component';

// CLMTLK Inbox
import { InboxComponent } from './clmtlk/inbox/inbox.component';
import { MessageGridComponent } from './clmtlk/inbox/message-grid/message-grid.component';
import {InboxService } from './clmtlk/inbox/shared/inbox.service';
import { InboxResolver } from './clmtlk/inbox/shared/inbox-resolver.service';

// CLMTLK New Message
import { NewMessageComponent } from './clmtlk/new-message/new-message.component';
import {NewMessageService } from './clmtlk/new-message/shared/new-message.service';
import {MessageFormComponent } from './clmtlk/new-message/message-form/message-form.component';
import {AutoCompleteComponent } from './clmtlk/new-message/message-form/auto-complete/auto-complete.component';
import {FileUploadComponent } from './clmtlk/new-message/message-form/file-upload/file-upload.component';
import {MessageEditorComponent } from './clmtlk/new-message/message-form/message-editor/message-editor.component';
import { NewMessageResolver } from 'app/clmtlk/new-message/shared/new-message-resolver.service';
import { CheckForInternalContactValidator } from 'app/clmtlk/new-message/message-form/check-internal-contact-validator.directive';

// CLMTLK Thread
import { ThreadComponent } from './clmtlk/thread/thread.component';
import {ThreadService } from './clmtlk/thread/thread.service';
import { AutoCompleteResolver } from 'app/clmtlk/new-message/shared/autocomplete-resolver.service';
import { ConfirmDialogModule, ConfirmationService} from 'primeng/primeng';
import { AccordionModule} from 'primeng/components/accordion/accordion';

@NgModule({
  declarations: [
    AppComponent,
    UnauthorizeComponent,
    LoginComponent,
    InboxComponent,
    MessageGridComponent,
    NewMessageComponent,
    MessageFormComponent,
    AutoCompleteComponent,
    FileUploadComponent,
    MessageEditorComponent,
    CheckForInternalContactValidator,
    ThreadComponent
  ],
  imports: [
    BrowserModule,
     NoopAnimationsModule,
    HttpModule,
    FormsModule,
    DataTableModule,
    SharedModule,
    ConfirmDialogModule,
    AutoCompleteModule,
    RadioButtonModule,
    InputMaskModule,
    FileUploadModule,
    MenuModule,
    ButtonModule,
    UiSwitchModule,
    CheckboxModule,
    NgbModalModule.forRoot(),
    ToastrModule.forRoot({maxOpened: 1, preventDuplicates: true}),
    //  InMemoryWebApiModule.forRoot(InMemoryClmtlkMockService, {delay: 300, passThruUnknownUrl: true}),
    Ng2Webstorage.forRoot({ prefix: 'clmtlk', separator: '|', caseSensitive: true }),
    BlockUIModule,
    CoreModule,
    ClmtlkSharedModule,
    SelectButtonModule,
    // InboxModule,
    // ThreadModule,
    // NewMessageModule,
    AppRoutingModule,
    AccordionModule
  ],
  providers: [ClmtlkService,
    ClmtlkSessionService,
    ExceptionService,
    HelperService,
    WindowRefService,
    GoogleAnalyticsService,
    DatePipe,
    ClmtlkCanDeactivate,
    InboxService,
    InboxResolver,
    NewMessageService,
    NewMessageResolver,
    ThreadService,
    AutoCompleteResolver,
    ConfirmationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/app.module.ts